import { Box, Grid } from "@mui/material";
import React, { Suspense } from "react";
import { useThemeProvider } from "../../../providers/ThemeProvider";
import AnnouncementCarouselComponent from "../../carousel/AnnouncementCarouselComponent";
import MainHeaderCarouselComponent from "../../carousel/MainHeaderCarouselComponent";
import { MainPageQuickTradeElementComponent } from "./QuickBuySellComponent";
import MainAppBarComponent from "../../appBars/MainAppBarComponent";
import { WaveShapeComponent } from "../../shapes/WaveShapeComponent";
import CoinListMainTabComponent from "../../tabs/CoinListMainTabComponent";
import { SampleFooterComponent } from "../../footers/SampleFooterComponent";

const ExploreProductPageComponent = React.lazy(() =>
  import("./ExploreProductPageComponent")
);
const DownloadAppsPageComponent = React.lazy(() =>
  import("./DownloadAppsPageComponent")
);
const NeedHelpPageComponent = React.lazy(() =>
  import("./NeedHelpPageComponent")
);
const PartnersPageComponent = React.lazy(() =>
  import("./PartnersPageComponent")
);

export const MainPageComponent = () => {
  return (
    <div>
      <MainAppBarComponent />
      <AnnouncementCarouselComponent />
      <MainHeaderCarouselComponent />
      {/* <Box
        marginY={{ md: 5, xs: 2 }}
        paddingX={{ md: 7, xs: 2 }}
        position="relative"
      >
        <WaveShapeComponent position="right" />
        <CoinListMainTabComponent />
      </Box> */}
      <Suspense fallback={<div>...</div>}>
        <Box paddingY={3} />
        <ExploreProductPageComponent />
      </Suspense>
      <Suspense fallback={<div>...</div>}>
        <Box paddingY={3} />
        <DownloadAppsPageComponent />
      </Suspense>
      <Suspense fallback={<div>...</div>}>
        <Box paddingY={3} />
        <NeedHelpPageComponent />
      </Suspense>
      <Suspense fallback={<div>...</div>}>
        <PartnersPageComponent />
      </Suspense>
      <SampleFooterComponent />
    </div>
  );
};
